<template>
  <div>
    <b-row v-for="birthday in birthdayList">
      <b-col cols="10">
        <p> {{ birthday.content }}</p>
      </b-col>
      <b-col cols="2" class="text-right">
        <p>2018-01-01</p>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'Message',
  components: {},
  created() {
    this.$store.dispatch(
      'Homepage/getMessageList', {
        count: 20,
        page: this.currentPage + 1,
        simple: true,
        formatted: true
      }).then((json) => {
      console.debug(json.list);
      this.birthdayList = json.list;
    }).catch((err) => {
      console.error(err);
    });
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Notification/components/Message.vue